import { Pipe, PipeTransform, inject, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

/**
 * Translate Pipe
 * 
 * Pipe for translating text in templates
 * 
 * @example
 * ```html
 * <h1>{{ 'welcome.title' | translate }}</h1>
 * <p>{{ 'welcome.message' | translate: { name: 'John' } }}</p>
 * ```
 */
@Pipe({
  name: 'translate',
  standalone: true,
  pure: false, // Not pure to react to locale changes
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private readonly transloco = inject(TranslocoService);
  private readonly cdr = inject(ChangeDetectorRef);
  private subscription?: Subscription;
  private lastKey?: string;
  private lastParams?: Record<string, any>;
  private lastValue?: string;

  transform(key: string, params?: Record<string, any>): string {
    if (!key) {
      return '';
    }

    // Subscribe to locale changes if not already subscribed
    if (!this.subscription || this.lastKey !== key || this.lastParams !== params) {
      this.lastKey = key;
      this.lastParams = params;
      
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.subscription = this.transloco.langChanges$.subscribe(() => {
        this.lastValue = this.transloco.translate(key, params || {});
        this.cdr.markForCheck();
      });
    }

    this.lastValue = this.transloco.translate(key, params || {});
    return this.lastValue;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

